import { httpClient } from '#shared/index'
import { createBatcher } from '#shared/lib/batching/create-batcher'
import { type GetGifsResponse } from '../model/get-gifs-response'
import type { GifObject } from '../model/gif-object'

async function getGifsByIds(ids: string[]): Promise<GifObject[]> {
  if (!ids.length) return []

  const searchParams = new URLSearchParams([
    ['key', import.meta.env.VITE_TENOR_API_KEY],
    ['media_filter', 'tinywebm,nanowebppreview_transparent,webp_transparent,mediumgif,preview'],
    ['ids', ids.join(',')],
  ])

  const response = httpClient.get<GetGifsResponse>(`posts?${searchParams.toString()}`, {
    prefixUrl: import.meta.env.VITE_TENOR_BASE_API_URL,
    credentials: 'omit',
  })

  const parsedResponse = await response.json()
  return parsedResponse.results
}

const getGifsByIdBatcher = createBatcher((calls: [string][]) => getGifsByIds(calls.flat()))

export async function getGifById(id: string): Promise<GifObject | null> {
  if (!id) return null

  const gif = await getGifsByIdBatcher.run(id)

  return gif
}
